import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import type { Observable } from 'rxjs';
import { AuthRequestDto, AuthResponseDto } from '../models/auth.dto';
import { ApiResponseDto } from '@common/models/api-response.dto';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(private http: HttpClient) {}

  login(request: AuthRequestDto): Observable<ApiResponseDto<AuthResponseDto>> {
    return this.http.post<ApiResponseDto<AuthResponseDto>>('/login', request);
  }
}
